import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiLicenseChartModule } from '@components/shared/license/ui-license-chart.module';
import { UiLicenseDashboardComponent } from '@components/shared/license/ui-license-dashboard.component';
import { UiLicenseStatusModule } from '@components/shared/license/ui-license-status.module';
import { UiLicenseUsageModule } from '@components/shared/license/ui-license-usage.module';
import { SharedModule } from '@modules';
import { UiDragAndDropModule } from '@uipath/angular/directives/ui-drag-and-drop-file';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UiLicenseStatusModule,
        UiLicenseUsageModule,
        UiLicenseChartModule,
        SharedModule,
        UiDragAndDropModule,
        UiSpinnerButtonModule,
    ],
    declarations: [
        UiLicenseDashboardComponent,
    ],
    exports: [
        UiLicenseDashboardComponent,
    ],
})
export class UiLicenseDashboardModule { }
